import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController, NavParams } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';

@Component({
  selector: 'app-notificacao-detalhe',
  templateUrl: './notificacao-detalhe.page.html',
  styleUrls: ['./notificacao-detalhe.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    DateFormatPipe,
    LoadingSpinnerComponent,
    SafeHtmlPipe
  ]
})
export class NotificacaoDetalhePage implements OnInit {
  loaded: boolean = false;
  detalhes: any;

  constructor(
    public navParams: NavParams,
    public modalCtrl: ModalController,
  ) { 
    this.detalhes = this.navParams.get('detalhes')
  }

  ngOnInit() {
    setTimeout(() => {
      this.loaded = true;
    }, 600);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
